const sortBy: {
  id: any;
  label: string;
  value: number;
}[] = [
  {
    id: 'sort-pos',
    label: 'Position',
    value: 0,
  },
  {
    id: 'sort-name-asc',
    label: 'Name: A to Z',
    value: 1,
  },
  {
    id: 'sort-name-desc',
    label: 'Name: Z to A',
    value: 2,
  },
  {
    id: 'sort-price-asc',
    label: 'Price: Low to High',
    value: 3,
  },
  {
    id: 'sort-price-desc',
    label: 'Price: High to Low',
    value: 4,
  },
  // {
  //   id: 'sort-date',
  //   label: 'Created on',
  //   value: 5,
  // },
];

const display: {
  id: any;
  label: string;
  value: number;
}[] = [
  {
    id: 'item-count-12',
    label: '12',
    value: 12,
  },
  {
    id: 'item-count-24',
    label: '24',
    value: 24,
  },
  {
    id: 'item-count-36',
    label: '36',
    value: 36,
  },
];

export { sortBy, display };
